$( document ).ready(function() {
  $(".cnpj").mask("00.000.000/0000-00");
  $(".money").maskMoney({prefix:'R$ ', allowNegative: true, thousands:'.', decimal:',', affixesStay: false});
  $(".whatsapp").mask("(00) 00000-0000");
});
